import { render, staticRenderFns } from "./LogAuditoria.vue?vue&type=template&id=db0645b4&scoped=true&"
import script from "./LogAuditoria.vue?vue&type=script&lang=js&"
export * from "./LogAuditoria.vue?vue&type=script&lang=js&"
import style0 from "./LogAuditoria.vue?vue&type=style&index=0&id=db0645b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db0645b4",
  null
  
)

export default component.exports